import React, { useEffect, useRef } from "react";
import {
  select,
  axisLeft,
  axisBottom,
  scalePoint,
  scaleLinear,
  line
} from "d3"; // we will need d3.js

function AxisBottom({ scale, transform }) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      select(ref.current).call(axisBottom(scale));
    }
  }, [scale]);

  return <g ref={ref} transform={transform} />;
}

function AxisLeft({ scale }) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      select(ref.current).call(axisLeft(scale));
    }
  }, [scale]);

  return <g ref={ref} />;
}

function Lines({ data, color, height, scaleX, scaleY }) {
  const lineBuilder = line().x((d) => scaleX(d.label)).y((d) => scaleY(d.value));
  const linePath = lineBuilder(data);

  return (
    <>
      <path
        d={linePath}
        stroke={color}
        fill="none"
        strokeWidth={2}
    />
    </>
  );
}

const LineChart = ({width: tWidth, height: tHeight, color, xRange, data}) => {
  const margin = { top: 10, right: 0, bottom: 20, left: 60 };
  const width = tWidth - margin.left - margin.right;
  const height = tHeight - margin.top - margin.bottom;

  const scaleX = scalePoint()
    .domain(data.map(({ label }) => label))
    .range([0, width])
    .padding(0.5);
  const scaleY = scaleLinear()
    .domain([0, Math.max(...data.map(({ value }) => value))])
    .range([height, 0]);

  return (
    <svg
      width={width + margin.left + margin.right}
      height={height + margin.top + margin.bottom}
      style={{backgroundColor: 'white'}}
    >
      <g transform={`translate(${margin.left}, ${margin.top})`}>
        <AxisBottom scale={scaleX} transform={`translate(0, ${height})`} />
        <AxisLeft scale={scaleY} />
        <Lines data={data} color={color} height={height} scaleX={scaleX} scaleY={scaleY} />
      </g>
    </svg>
  );
}; export default LineChart;